export enum StylesVariablesEnum {
  Primary = '--primary',
  ContrastText = '--contrast-text',
  PrimaryLight = '--primary-light',
  PrimaryLighter = '--primary-lighter',
  PrimaryDark = '--primary-dark',
  PrimaryDarker = '--primary-darker',
  DarkText = '--dark-text',
  LightText = '--light-text',
  LightFill = '--light-fill',
  LightBorder = '--light-border',
  MediumFill = '--medium-fill',
  FontWeightBold = '--font-weight-bold',
  FontWeightRegular = '--font-weight-regular',
  SmallTextSize = '--small-text-size',
  InteractableLineHeight = '--interactable-line-height',
  Red = '--red',
  Danger = '--danger',
  GridGutterWidth = '--grid-gutter-width',
  InputBorderColor = '--input-border-color',
  InputFocusBorderColor = '--input-focus-border-color',
  InputBtnFocusBoxShadow = '--input-btn-focus-box-shadow',
  InputBtnFocusWidth = '--input-btn-focus-width',
  CardBorderColor = '--card-border-color',
  FormLabelMarginBottom = '--form-label-margin-bottom',
  FormLabelFontSize = '--form-label-font-size',
  InputLineHeight = '--input-line-height',
  ModalBackdropBg = '--modal-backdrop-bg',
  ModalBackdropOpacity = '--modal-backdrop-opacity',
  BorderRadius = '--border-radius',
  BorderRadiusSm = '--border-radius-sm',
  BorderRadiusLg = '--border-radius-lg',
  BorderRadiusPill = '--border-radius-pill',
  CardBorderRadius = '--card-border-radius',
  BackgroundPage = '--background-page',
  BackgroundControlsDark = '--background-controls-dark',
  BackgroundControlsDarker = '--background-controls-darker',
  BackgroundControlsMedium = '--background-controls-medium',
  BackgroundControlsLight = '--background-controls-light',
  BackgroundControlsLighter = '--background-controls-lighter',
  BsHeadingColor = '--bs-heading-color',
  BsBodyColor = '--bs-body-color',
  BoxShadow = '--box-shadow',
  BtnBoxShadow = '--btn-box-shadow',
  CardBody = '--card-body',
  BtnSecondary = '--btn-secondary',
  TableRow = '--table-row',
  TableText = '--table-text',
  BackgroundOverlayPopup = '--background-overlay-popup',
  BoxShadowOverlayPopup = '--box-shadow-overlay-popup',
  secondaryColorText = '--secondary-color-text',
  welcomeBackground = '--welcome-background'
}
